import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import i18n from './i18n';
import { detectLanguageForGuest, getLanguageFromStorage, convertToI18nFormat } from './utils/languageDetection';

// Synchronously set language before first render to prevent flicker
(() => {
  try {
    const stored = getLanguageFromStorage();
    const initial = stored ?? detectLanguageForGuest();
    const i18nLang = convertToI18nFormat(initial);
    i18n.changeLanguage(i18nLang);
  } catch (err) {
    // Fallback silently if anything goes wrong
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Регистрация Service Worker для PWA (только один раз)
if ('serviceWorker' in navigator && !(window as any).serviceWorkerRegistered) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        (window as any).serviceWorkerRegistered = true;
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}